import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(email, password);

      // Navigate to 2FA verification page with response data
      navigate('/verify-2fa', {
        state: {
          email: email,
          qrCode: response.qrCode,
        },
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex font-['Mulish']">
      {/* Left Side - Illustration */}
      <div className="hidden md:flex md:w-7/12 bg-light items-center justify-center">
        <div className="relative text-center">
          <div 
            className="absolute inset-0 bg-accent/30 -z-10 rounded-2xl"
          />
          <img 
            src="/undrawlost.svg" 
            alt="Lost Illustration" 
            className="max-h-[75vh] opacity-90 relative z-10" 
          />
          <div 
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-secondary/20 rounded-full -z-10 blur-3xl"
          />
        </div>
      </div>
      
      {/* Right Side - Login Form */}
      <div className="flex-1 flex flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full mx-auto">
          <div className="text-center mb-8">
            <span className="font-['Mulish'] text-primary text-3xl font-extrabold tracking-tight">
              Reg<span className="text-secondary">Medical</span>
            </span>
            <h2 className="mt-6 text-xl font-semibold text-neutral">Welcome Back!</h2>
            <p className="mt-2 text-sm text-neutral">Please sign in to your account</p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                type="email"
                className="w-full px-4 py-3 rounded-lg border border-light focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-primary placeholder-neutral/60"
                placeholder="email@medical.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            
            <div>
              <input
                type="password"
                className="w-full px-4 py-3 rounded-lg border border-light focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-primary placeholder-neutral/60"
                placeholder="••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="rememberMe"
                  className="w-4 h-4 rounded border-light text-primary focus:ring-primary"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <label className="ml-2 text-neutral" htmlFor="rememberMe">
                  Remember Me
                </label>
              </div>
              <button type="button" className="text-primary hover:text-primary-dark font-semibold">
                Forgot password?
              </button>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-primary hover:bg-primary-dark text-white font-semibold rounded-lg transition-colors duration-200 uppercase disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {loading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Logging in...
                </>
              ) : (
                'LOGIN'
              )}
            </button>
          </form>
          
          <div className="text-center mt-8">
            <p className="text-neutral">
              Copyright to Medical Registry 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 